var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucessoVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28a745",
    d: "M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessoVerde);
export default __webpack_public_path__ + "static/media/sucesso-verde.7faaf2aa2dae887c59765c49151abb1f.svg";
export { ForwardRef as ReactComponent };